globalThis.Lang = globalThis.Lang || {};

globalThis.Lang.dateRangePicker = {
  locale: 'fr',
  t: function(path) {
    var translation = undefined,
        pathArray = path.split('.');

    for(var i = 0; i < pathArray.length; i++) {
      translation = (translation || this)[pathArray[i]];

      if(!translation) break;
    }

    return translation || ('Missing translation for : ' + path);
  },
  moment: {
    months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin',  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
    monthsShort: ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'août', 'sep', 'oct', 'nov', 'déc'],
    weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    weekdaysShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
    weekdaysMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    longDateFormat : {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY LT',
      LLLL: 'dddd D MMMM YYYY LT'
    }
  },
  apply: 'Appliquer',
  cancel: 'Annuler',
  customizedPeriod: 'Période personnalisée'
}
